<!--IS DISABLED-->
<div *ngIf='!isEnabled && item.type !== "LINK_SEPARATOR"'
     [disableTooltip]='!showLabelTooltip'
     [ngClass]='{
        "sidebar-link--collapsed": collapsed,
        "sidebar-link--submenu": isSubMenu()
      }'
     [ngbTooltip]='item?.label | async'
     class='sidebar-link link-btn {{classCss}} sidebar-link--disabled' container='body'
     placement='right'
     tooltipClass='side-bar-tooltip'>

  <ng-container [ngSwitch]='linkType'>
    <ng-container *ngSwitchCase='"LINK"'>
      <pt-icon *ngIf='item?.icon'
               [iconType]="item.icon?.type"
               [key]='item.icon?.key'
               [size]="16">
      </pt-icon>
      <label>
        {{ item?.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
      </label>
    </ng-container>

    <ng-container *ngSwitchCase='"SUB_MENU"'>
      <pt-icon *ngIf='item?.icon'
               [iconType]="item.icon?.type"
               [key]='item.icon?.key'
               [size]="16">
      </pt-icon>
      <div *ngIf='!item?.icon' class='submenu-separator'></div>
      <label>
        <div *ngIf='isLeafItemLink()' [innerHTML]="'»&nbsp;'"></div>
        {{ item?.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
      </label>
    </ng-container>

    <ng-container *ngSwitchCase='"COLLAPSED_LINK"'>
      <pt-icon *ngIf='item?.icon'
               [iconType]="item.icon?.type"
               [key]='item.icon?.key'
               [size]="16">
      </pt-icon>
    </ng-container>

    <ng-container *ngSwitchCase='"COLLAPSED_SUB_MENU"'>

      <div class='collapsed-sub-menu'>
        <!--        <div class='link-collapsed-active'></div>-->
        <pt-icon *ngIf='item?.icon'
                 [iconType]="item.icon?.type"
                 [key]='item.icon?.key'
                 [size]="16">
        </pt-icon>

        <label>
          <div *ngIf='isLeafItemLink()' [innerHTML]="'»&nbsp;'"></div>
          {{ item?.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
        </label>
      </div>
    </ng-container>
  </ng-container>
</div>

<!--IS ENABLED-->
<a #rla='routerLinkActive' *ngIf='isEnabled && item.type !== "LINK_SEPARATOR"'
   [ngClass]='{"sidebar-link--collapsed": collapsed, "sidebar-link--submenu": isSubMenu()}'
   [routerLinkActiveOptions]='{ exact: false }'
   [routerLink]="'/' + item.routerLink"
   class='sidebar-link link-btn {{classCss}}'
   ctrl-click
   routerLinkActive='sidebar-link--active'>
  <ng-container [ngSwitch]='linkType'>
    <ng-container *ngSwitchCase='"LINK"'>
      <div *ngIf='rla.isActive' class='link-active'></div>
      <pt-icon *ngIf='item?.icon'
               [iconType]="item.icon?.type"
               [key]='item.icon?.key'
               [size]="16">
      </pt-icon>
      <label [ngClass]='{"bold": rla.isActive}'>
        {{ item?.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
      </label>
    </ng-container>

    <ng-container *ngSwitchCase='"SUB_MENU"'>
      <pt-icon *ngIf='item?.icon'
               [iconType]="item.icon?.type"
               [key]='item.icon?.key'
               [size]="16">
      </pt-icon>
      <div *ngIf='!item?.icon' class='submenu-separator'></div>
      <label [ngClass]='{"bold": rla.isActive}'>
        <div *ngIf='rla.isActive' class='submenu-active'></div>
        <div *ngIf='isLeafItemLink()' [innerHTML]="'»&nbsp;'"></div>
        {{ item?.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
      </label>
    </ng-container>

    <ng-container *ngSwitchCase='"COLLAPSED_LINK"'>
      <div *ngIf='rla.isActive' class='link-collapsed-active'></div>
      <pt-icon *ngIf='item?.icon'
               [iconType]="item.icon?.type"
               [key]='item.icon?.key'
               [size]="16">
      </pt-icon>
      <div *ngIf="item?.label && showLabelTooltip" class="collapsed-label">
        {{ item.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase='"COLLAPSED_SUB_MENU"'>
      <div class='collapsed-sub-menu'>
        <div *ngIf='rla.isActive' class='link-collapsed-active'></div>
        <pt-icon *ngIf='item?.icon'
                 [iconType]="item.icon?.type"
                 [key]='item.icon?.key'
                 [size]="16">
        </pt-icon>
        <label>
          <div *ngIf='isLeafItemLink()' [innerHTML]="'»&nbsp;'"></div>
          {{ item?.label | async }} <span class="badge bg-app-color ms-1 mb-2" *ngIf="item?.isBetaEnabled">Beta</span>
        </label>
      </div>
    </ng-container>
  </ng-container>
</a>

<span *ngIf='item.type === "LINK_SEPARATOR"' class='sidebar-link-separator'>{{ item?.label | async }}</span>
